export default "__VITE_ASSET__4f718ddd__"